
import { App } from '../desertland.app';
import { ROUTES } from '../desertland.router';
import 'kendo-ui-core';
// import 'kendo-ui-core/js/kendo.observable';

declare var log, info, warn, groupCollapsed, groupEnd;

/**
 * NIDs for each PAGE to find
 */
const PAGEIDS = {
  [ROUTES.HOME]: "465",
  [ROUTES.ABOUT]: "435",
  [ROUTES.CONTACT]: "460",
  [ROUTES.IDEAS]: "461",
  [ROUTES.PLANT]: "plant", // TODO: Verify
  [ROUTES.PLANTS]: "466",
  [ROUTES.LEARN]: "1068",
  [ROUTES.TIPS]: "463",
  [ROUTES.TRIVIA]: "464",
  [ROUTES.RESOURCES]: "462",
  [ROUTES.BIBLIOGRAPHY]: "1069",
  [ROUTES.HISTORY]: "1070",
  [ROUTES.ACKNOWLEDGE]: "1071",
};

const findPage = (p) => {
  // return p.node_title.toLowerCase() === App.currentPage.toLowerCase();// not a valid key to compare - can be changed by user in Drupal
  return p.nid === PAGEIDS[App.currentPage];
};

export class PageViewModel {

  public viewModel = kendo.observable({

    defaults: {
      title: "Desert Landscaping",
      tagline: "Valuable Resources for Desert Gardening",
      hero_img: "",
      hero_img_alt: "",
      header: "",
      desc_text: ""
    },

    page: "index",
    node_title: "index", // not a valid key to compare - can be changed by user in Drupal
    nid: "465", // key to compare to page

    title: "Valuable Resources for Desert Gardening",
    tagline: "Valuable Resources for Desert Gardening",

    hero_img: "remsberg_13051034573-retouched.jpg",
    hero_img_alt: "Hero Image photo by Edwin Remsberg",

    header: "",
    desc_text: "",

    getHero: () => {
      return (this.get("hero_img")) ? App.config.img_url.hero + this.viewModel.get("hero_img") : '';
    },
    
    hasBgImage: () => {
      return (this.get("hero_img"));
    },
    
    getBackgroundImage: () => {
      return (this.get("hero_img")) ? 'url(' + App.config.img_url.hero + this.get("hero_img") + ')' : '';
    },

    isCurrent: () => {
      return App.currentPage === this.get("page");
    },
    isCurrentRoute: (name) => {
      return this.get("page") === name;
    },
    isCurrentHome: () => {
      return this.get("page") === ROUTES.HOME;
    },
    isCurrentPlants: () => {
      return this.get("page") === ROUTES.PLANTS;
    },
    isCurrentTips: () => {
      return this.get("page") === ROUTES.TIPS;
    },
    isCurrentIdeas: () => {
      return this.get("page") === ROUTES.IDEAS;
    },
    isCurrentTrivia: () => {
      return this.get("page") === ROUTES.TRIVIA;
    },
    isCurrentAbout: () => {
      return this.get("page") === ROUTES.ABOUT;
    },
    isCurrentContact: () => {
      return this.get("page") === ROUTES.CONTACT;
    },
    isCurrentLearnmore: () => {
      return this.get("page") === ROUTES.LEARN 
          || this.get("page") === ROUTES.RESOURCES
          || this.get("page") === ROUTES.BIBLIOGRAPHY
          || this.get("page") === ROUTES.HISTORY
          || this.get("page") === ROUTES.ACKNOWLEDGE;
    },
    isCurrentResources: () => {
      return this.get("page") === ROUTES.RESOURCES;
    },
    isCurrentBiblio: () => {
      return this.get("page") === ROUTES.BIBLIOGRAPHY;
    },
    isCurrentHistory: () => {
      return this.get("page") === ROUTES.HISTORY;
    },
    isCurrentAcknowledge: () => {
      return this.get("page") === ROUTES.ACKNOWLEDGE;
    },

  
    isCurrentPlantsText() {
      return (this.get('isCurrentPlants')) ? "(current page)" : "";
    },
    isCurrentTipsText() {
      return (this.get('isCurrentTips')) ? "(current page)" : "";
    },
    isCurrentIdeasText: () => {
      return (this.get('isCurrentIdeas')) ? "(current page)" : "";
    },
    isCurrentTriviaText: () => {
      return (this.get('isCurrentTrivia')) ? "(current page)" : "";
    },
    isCurrentAboutText: () => {
      return (this.get('isCurrentAbout')) ? "(current page)" : "";
    },
    isCurrentContactText: () => {
      return (this.get('isCurrentContact')) ? "(current page)" : "";
    },
    isCurrentLearnmoreText: () => {
      return (this.get('isCurrentContact')) ? "(current page)" : "";
    },
    isCurrentResourcesText: () => {
      return (this.get('isCurrentResources')) ? "(current page)" : "";
    },
    isCurrentBiblioText: () => {
      return (this.get('isCurrentBiblio')) ? "(current page)" : "";
    },
    isCurrentHistoryText: () => {
      return (this.get('isCurrentHistory')) ? "(current page)" : "";
    },
    isCurrentAcknowledgeText: () => {
      return (this.get('isCurrentAcknowledge')) ? "(current page)" : "";
    },
  
  
    // displayGreeting: () => {
    //   let name = this.get("title");
    //   log("Greetings, " + name + "!!!");
    // },
  });


  public updatePage = (data) => {
    log("updatePage", data);

    if (data && data.length) {
      
      let thisPage = data.find(findPage);

      if (thisPage) {
        info("found the page:", thisPage);
        this.viewModel.set("title", thisPage.title);
        this.viewModel.set("tagline", thisPage.tagline);
        this.viewModel.set("hero_img", thisPage.hero_img);
        this.viewModel.set("hero_img_alt", thisPage.hero_img_alt);

        this.viewModel.set("header", thisPage.header);
        this.viewModel.set("desc_text", thisPage.desc_text);
      } else {
        info("no page found", data);
        this.viewModel.set("title", this.viewModel.get('defaults.title'));
        this.viewModel.set("tagline", this.viewModel.get('defaults.tagline'));
        this.viewModel.set("hero_img", this.viewModel.get('defaults.hero_img'));
        this.viewModel.set("hero_img_alt", this.viewModel.get('defaults.hero_img_alt'));

        this.viewModel.set("header", this.viewModel.get('defaults.header'));
        this.viewModel.set("desc_text", this.viewModel.get('defaults.desc_text'));
      }

      this.viewModel.set("page", App.currentPage);
    }
  }


  // public hasBgImage() {
  //   let img = this.viewModel.get("hero_img");
  //   //info(img);
  //   if (img) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }

  public get(prop: string) {
    return this.viewModel.get(prop);
  }

  // public getBackgroundImage() {
  //   let img = this.viewModel.get("hero_img");
  //   //info(img);
  //   // info(App.config.img_url);
  //   if (img) {
  //     return 'url(' + App.config.img_url.hero + img + ')';
  //   } else {
  //     return '';
  //   }
  // }

  // public getHero() {
  //   let img = this.viewModel.get("hero_img");
  //   //info(img);
  //   // info(App.config.img_url);
  //   if (img) {
  //     return App.config.img_url.hero + img;
  //   } else {
  //     return '';
  //   }
  // }

  // public getCurrentPage() {
  //   return this.viewModel.get("page");
  // }
  // public isCurrent() {
  //   return App.currentPage === this.viewModel.get("page");
  // }
  // public isCurrentHome() {
  //   return this.getCurrentPage() === ROUTES.HOME;
  // }
  // public isCurrentPlants() {
  //   let page = this.getCurrentPage();
  //   return page === ROUTES.PLANTS;// || page === ROUTES.PLANT;
  // }
  // public isCurrentTips() {
  //   return this.getCurrentPage() === ROUTES.TIPS;
  // }
  // public isCurrentIdeas() {
  //   return this.getCurrentPage() === ROUTES.IDEAS
  // }
  // public isCurrentTrivia() {
  //   return this.getCurrentPage() === ROUTES.TRIVIA;
  // }
  // public isCurrentResources() {
  //   return this.getCurrentPage() === ROUTES.RESOURCES;
  // }
  // public isCurrentAbout() {
  //   return this.getCurrentPage() === ROUTES.ABOUT;
  // }
  // public isCurrentContact() {
  //   return this.getCurrentPage() === ROUTES.CONTACT;
  // }
  // public isCurrentLearnmore() {
  //   return this.getCurrentPage() === ROUTES.LEARN;
  // }

  // public isCurrentPlantsText() {
  //   return (this.isCurrentPlants) ? "(current page)" : "";
  // }
  // public isCurrentTipsText() {
  //   return (this.isCurrentTips) ? "(current page)" : "";
  // }
  // public isCurrentIdeasText() {
  //   return (this.isCurrentIdeas) ? "(current page)" : "";
  // }
  // public isCurrentTriviaText() {
  //   return (this.isCurrentTrivia) ? "(current page)" : "";
  // }
  // public isCurrentResourcesText() {
  //   return (this.isCurrentResources) ? "(current page)" : "";
  // }
  // public isCurrentAboutText() {
  //   return (this.isCurrentAbout) ? "(current page)" : "";
  // }
  // public isCurrentContactText() {
  //   return (this.isCurrentContact) ? "(current page)" : "";
  // }
  // public isCurrentLearnmoreText() {
  //   return (this.isCurrentLearnmore) ? "(current page)" : "";
  // }

}
